import {

    REGISTER_USER_REQUEST,
    REGISTER_USER_SUCCESS,
    REGISTER_USER_FAIL,
    CLEAR_ERRORS,



    VERIFY_TIME_REQUEST,
    VERIFY_TIME_SUCCESS,
    VERIFY_TIME_FAIL,

    RESEND_EMAIL_REQUEST,
    RESEND_EMAIL_SUCCESS,
    RESEND_EMAIL_FAIL,


    VERIFY_EMAIL_REQUEST,
    VERIFY_EMAIL_SUCCESS,
    VERIFY_EMAIL_FAIL,


    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAIL,


    LOGOUT_SUCCESS,
    LOGOUT_FAIL,


    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL,


    LOAD_USER_REQUEST,
    LOAD_USER_SUCCESS,
    LOAD_USER_FAIL,


    FORGET_PASSWORD_REQUEST,
    FORGET_PASSWORD_SUCCESS,
    FORGET_PASSWORD_FAIL,


    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAIL,


    ALL_USERS_REQUEST,
    ALL_USERS_SUCCESS,
    ALL_USERS_FAIL,


    UPDATE_ROLE_REQUEST,
    UPDATE_ROLE_SUCCESS,
    UPDATE_ROLE_FAIL,

    UPDATE_USER_RESET,



    UPDATE_AVATAR_REQUEST,
    UPDATE_AVATAR_SUCCESS,
    UPDATE_AVATAR_FAIL,



    CLEAR_MESSAGES,
    REGISTER_USER_RESET,
    RESEND_EMAIL_RESET,
    FORGET_PASSWORD_RESET,
    UPDATE_AVATAR_RESET

} from "../constants/userConstant"

export const RegisterReducer = (state = { user: {} }, action) => {

    switch (action.type) {
        case REGISTER_USER_REQUEST:
        case LOGIN_REQUEST:
            return {
                loading: true,
            }

        case REGISTER_USER_SUCCESS:
        case LOGIN_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message
            }

        case REGISTER_USER_FAIL:
        case LOGIN_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: null // optional: clear old message
            }
        case REGISTER_USER_RESET:
            return {
                ...state,
                loading: false,
                message: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}

export const verifyTimeReducer = (state = { time: {} }, action) => {

    switch (action.type) {
        case VERIFY_TIME_REQUEST:
            return {
                loading: true,
            }

        case VERIFY_TIME_SUCCESS:
            return {
                ...state,
                loading: false,
                expiryTime: action.payload
            }

        case VERIFY_TIME_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                expireyTime: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}



export const resendEmailReducer = (state = { email: {} }, action) => {

    switch (action.type) {
        case RESEND_EMAIL_REQUEST:
            return {
                loading: true,
            }

        case RESEND_EMAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                message: action.payload.message,
                expireTime: action.payload.expireTime
            }

        case RESEND_EMAIL_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                expireyTime: null, // optional: clear old message
                message: null // optional: clear old message
            }
        case RESEND_EMAIL_RESET:
            return {
                ...state,
                loading: false,
                message: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}

export const verifyEmailReducer = (state = { user: {} }, action) => {

    switch (action.type) {
        case VERIFY_EMAIL_REQUEST:
        case LOAD_USER_REQUEST:
        case RESET_PASSWORD_REQUEST:
            return {
                loading: true,
            }

        case VERIFY_EMAIL_SUCCESS:
        case LOAD_USER_SUCCESS:
        case RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                user: action.payload.user,
                isAuthenticated: true,
                isLoggedout: false
            }

        case VERIFY_EMAIL_FAIL:
        case LOAD_USER_FAIL:
        case RESET_PASSWORD_FAIL:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
                user: null, // optional: clear old message
                isAuthenticated: false,
                isLoggedout: true
            }
        case LOGOUT_SUCCESS:
            return {
                loading: false,
                user: null, // optional: clear old message
                isAuthenticated: false, // optional: clear old message
                isLoggedout: true
            }
        case LOGOUT_FAIL:
            return {
                loading: false,
                user: null, // optional: clear old message
                isAuthenticated: false, // optional: clear old message
                isLoggedout: false
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        case CLEAR_MESSAGES:

            return {
                ...state,
                message: null,
            }
        default:
            return state;
    }

}

export const updateUserReducer = (state = { user: {} }, action) => {

    switch (action.type) {
        case UPDATE_USER_REQUEST:
            return {
                loading: true,
            }

        case UPDATE_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                user: action.payload.user,
            }

        case UPDATE_USER_FAIL:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
                user: null, // optional: clear old message
            }
        case UPDATE_USER_RESET:
            return {
                ...state,
                user: null, // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}

export const forgotPasswordReducer = (state = { user: {} }, action) => {

    switch (action.type) {
        case FORGET_PASSWORD_REQUEST:
            return {
                loading: true,
            }

        case FORGET_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message
            }

        case FORGET_PASSWORD_FAIL:
            return {
                loading: false,
                error: action.payload,
                message: null // optional: clear old message
            }
        case FORGET_PASSWORD_RESET:
            return {
                loading: false,
                message: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}

export const allUsersReducer = (state = { users: {} }, action) => {

    switch (action.type) {
        case ALL_USERS_REQUEST:
            return {
                loading: true,
            }

        case ALL_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                users: action.payload.users
            }

        case ALL_USERS_FAIL:
            return {
                loading: false,
                error: action.payload,
                users: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}

export const updateRoleReducer = (state = { user: {} }, action) => {

    switch (action.type) {
        case UPDATE_ROLE_REQUEST:
            return {
                loading: true,
            }

        case UPDATE_ROLE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message
            }

        case UPDATE_ROLE_FAIL:
            return {
                loading: false,
                error: action.payload,
                user: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
                message: null,
            }
        default:
            return state;
    }

}




export const updateAvatarReducer = (state = { user: {} }, action) => {

    switch (action.type) {
        case UPDATE_AVATAR_REQUEST:
            return {
                loading: true,
            }

        case UPDATE_AVATAR_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message
            }

        case UPDATE_AVATAR_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        case UPDATE_AVATAR_RESET:

            return {
                ...state,
                message: null,
            }
        default:
            return state;
    }

}
